{
  const BaseModule = require('_base/base')

  const DIRECTIONS = ['top', 'right', 'bottom', 'left']

  class OpticalMargins extends BaseModule {
    preInit() {
      this.isFinal = true
      this.margins = []
    }

    postInit() {
      this.initialMargins = this.$el.css('margin')

      this.initMargins()
    }

    initMargins() {
      DIRECTIONS.forEach(direction => {
        const currentMargin = this.$el.css(`margin-${direction}`)
        const initialOpticalMargin = this.$el.data(`margin-${direction}`)

        if (initialOpticalMargin !== undefined) {
          this.margins.push({ direction, currentMargin, initialOpticalMargin })
        }
      })
    }

    postReset() {
      this.$el.css('margin', this.initialMargins)
    }

    postCalculate() {
      this.width = this.$el.attr('width') || this.$el.width()
      this.height = this.$el.attr('height') || this.$el.height()

      this.calculateCurrentOpticalMargins()
    }

    calculateCurrentOpticalMargins() {
      this.margins.forEach(margin => {
        const isRelative = String(margin.initialOpticalMargin).includes('%')

        margin.currentOpticalMargin = isRelative ? this.recalcRelativeMargin(margin) : margin.initialOpticalMargin
      })
    }

    recalcRelativeMargin(margin) {
      const measurement = margin.direction === 'top' || margin.direction === 'bottom' ? this.height : this.width
      const marginValue = parseFloat(margin.initialOpticalMargin).toFixed(2)

      return ((measurement * marginValue) / 100).toFixed(2) + 'px'
    }

    preRender() {
      this.margins.forEach(margin => {
        this.$el.css('margin-' + margin.direction, `calc(${margin.currentMargin} + ${margin.currentOpticalMargin})`)
      })

      this.spread.resize()
    }
  }

  $('.js__opticalMargin').each(function() {
    new OpticalMargins($(this))
  })
}
